import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Close: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="Close Square"><path id="Stroke 1" d="M16.9969 6.99365L7.00317 16.9873" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path id="Stroke 2" d="M17.0001 16.9934L6.99805 6.98926" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};